import React from 'react';
import { useQuery } from '@apollo/client';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import { parseUrl } from 'query-string';
import { getSingleEntitySchema, getItemList } from '../../application/query';
import CardsRender from './CardsRender';
import { buildPropsQuery, getGenericProps, checkPropsToUse } from '../../helpers';
import { WITH_BANNER } from '../../constants';
import { getItemListId, getItemListIds } from '../ItemList/helpers';

const CardsFactory = ({
  entity,
  entities,
  propsToDisplay,
  itemsToDisplay,
  itemListName,
  VariantComponent,
  ...cardProps
}) => {
  const entityTouse = entities && entities.length ? entities[0] : entity;
  const router = useRouter();
  const { asPath } = router;
  const parsedQuery = asPath.replace(/%5D/g, ']').replace(/%5B/g, '[');

  const { query: { itemListId: queryItemListId } = {} } = parseUrl(parsedQuery);

  const { data, error, loading } = useQuery(getSingleEntitySchema, {
    variables: { id: entityTouse }
  });

  const itemListId = getItemListId(itemListName, queryItemListId);

  const {
    data: itemListData = {},
    loading: itemListLoading,
    error: itemListError
  } = useQuery(getItemList, {
    variables: { id: itemListId },
    skip: !itemListId
  });

  if (loading || itemListLoading) return '';
  if (error || itemListError) return error.message || itemListError.message;
  if (!data) return null;

  const propsToDisplayValues = checkPropsToUse(propsToDisplay);
  const extraProps = buildPropsQuery(data, propsToDisplayValues, cardProps) || '';
  const { gridModifier, ...cardRenderProps } = getGenericProps(cardProps);
  const extraModifierForBanner = cardRenderProps.banner ? WITH_BANNER : '';

  const itemListIds = getItemListIds(itemListData);
  const itemsToDisplayToUse = itemListIds || itemsToDisplay;

  if (itemListName && !itemListIds) return null;

  return (
    <CardsRender
      gridModifier={`${gridModifier}${extraModifierForBanner}`}
      bannerModifier={extraModifierForBanner}
      itemsToDisplay={itemsToDisplayToUse}
      propsToDisplay={propsToDisplay}
      entityFields={extraProps}
      VariantComponent={VariantComponent}
      {...cardRenderProps}
      entity={entityTouse}
      entities={entities}
    />
  );
};

CardsFactory.propTypes = {
  entity: PropTypes.string,
  propsToDisplay: PropTypes.array,
  itemsToDisplay: PropTypes.array,
  itemListName: PropTypes.string,
  entities: PropTypes.array,
  VariantComponent: PropTypes.func
};

CardsFactory.defaultProps = {
  propsToDisplay: [],
  itemsToDisplay: [],
  itemListName: '',
  entity: null,
  entities: null,
  VariantComponent: null
};

export default CardsFactory;
